"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.submitItems = void 0;
var getDecisionData_1 = require("@utils/getDecisionData");
var apiService_1 = __importDefault(require("@common/services/apiService"));
var filterJobGroupsWithDecisions = function (jobGroups) {
    return jobGroups.filter(function (jobGroup) { var _a, _b, _c; return (_c = (_b = (_a = jobGroup.jobs) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.selectedDecision) === null || _c === void 0 ? void 0 : _c.type; });
};
var setDecisionToOlderJobs = function (jobGroup) {
    var jobs = jobGroup.jobs;
    var _a = __read(jobs), latestJob = _a[0], olderJobs = _a.slice(1);
    if (!(latestJob === null || latestJob === void 0 ? void 0 : latestJob.selectedDecision))
        return jobGroup;
    var decisionType = latestJob.selectedDecision.type === 'defer' ? 'defer' : 'no decision';
    var routingQueueObj = decisionType === 'defer' ? latestJob.routingQueueObj : undefined;
    var updatedOlderJobs = olderJobs.map(function (olderJob) { return (__assign(__assign({}, olderJob), { routingQueueObj: routingQueueObj !== null && routingQueueObj !== void 0 ? routingQueueObj : olderJob.routingQueueObj, selectedDecision: { type: decisionType } })); });
    return __assign(__assign({}, jobGroup), { jobs: __spreadArray([latestJob], __read(updatedOlderJobs), false) });
};
function submitItems(domain, jobGroups, queueName, queueId) {
    var filteredJobGroup = filterJobGroupsWithDecisions(jobGroups).map(function (jobGroup) { return setDecisionToOlderJobs(jobGroup); });
    var allJobs = filteredJobGroup.flatMap(function (jobGroup) { return jobGroup.jobs; });
    var data = allJobs.map(function (job) { return (0, getDecisionData_1.getSubmitDecisionApiData)(job); });
    var decisions = data.map(function (decision) { return (__assign(__assign({}, decision), { queueName: queueName, queueId: queueId })); });
    return apiService_1.default.putDecisionForMultipleJobs({ domain: domain }, { decisions: decisions });
}
exports.submitItems = submitItems;
